import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SiteNavigationService } from '../../core-services';

/**
 * The universal navigation component. This conditionally shows either the
 * 2.0 global nav or the legacy nav.
 */
@Component({
    selector: 'pi-universal-nav',
    templateUrl: './pi-universal-nav.component.html',
    standalone: false
})
export class PIUniversalNavComponent {
    @Input()
    disableSearch = false;
    @Input()
    disableGlobalNav = false;

    @Output()
    onUpgradeAccountClick: EventEmitter<any> = new EventEmitter();
    @Output()
    piAssistantClick: EventEmitter<void> = new EventEmitter();
    @Output()
    sellerToolsClick: EventEmitter<void> = new EventEmitter();
    @Output()
    moduleClick: EventEmitter<void> = new EventEmitter();
    @Input()
    buttonTextKeyName;

    constructor(public siteNavigation: SiteNavigationService) {}

    get showGlobalNav() {
        const eligibleModules: boolean[] = [
            this.siteNavigation.isInDesign2,
            this.siteNavigation.isInDiagnose,
            this.siteNavigation.isInHire,
            this.siteNavigation.isInInspire2,
            this.siteNavigation.isInSubscriptionsAndBilling,
            this.siteNavigation.isInTapestryPlayground,
            this.siteNavigation.isInPlatform,
            this.siteNavigation.isInAdmin,
            this.siteNavigation.isInGroupAnalytics,
            this.siteNavigation.isInSellerExperience
        ];
        return eligibleModules.some((appLocation) => appLocation === true);
    }
}
